import type { GivingDetail } from 'models';
import { useMemo } from 'react';

type P = {
  giving: GivingDetail;
};

export const useIsGivingOngoing = ({ giving }: P) => useMemo(() => giving.status === 'ongoing', [giving.status]);
